module.exports = __webpack_public_path__ + "static/media/boy-10.f97f1ab5.svg";